import React, { useEffect, useState } from 'react';
import { Box, TextField, MenuItem, Button, Typography } from '@mui/material';
import { useCreateAgencyMutation, useUpdateAgencyMutation, useGetAgencyByIdQuery } from '../../slices/agencyApiSlice';

import { useParams, useNavigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';


const tiers = ['Tier1', 'Tier2', 'Tier3', 'Tier4'];

const AgencyFormScreen = () => {
  const { id } = useParams(); // for edit
  const isEdit = Boolean(id);
const navigate = useNavigate();

  const [form, setForm] = useState({
    agencyName: '',
    agencyAddress: '',
    agencyPhone: '',
    agencyEmail: '',
    agencyTier: '',
    daysToShiftStart:100,
  });

  const { data: agency } = useGetAgencyByIdQuery(id, { skip: !isEdit });
  const [createAgency] = useCreateAgencyMutation();
  const [updateAgency] = useUpdateAgencyMutation();

  useEffect(() => {
  if (agency) {
   //console.log('Loaded agency data:', agency); // Debugging
    setForm({
      agencyName: agency.agencyName || '',
      agencyAddress: agency.agencyAddress || '',
      agencyPhone: agency.agencyPhone || '',
      agencyEmail: agency.agencyEmail || '',
      agencyTier: agency.agencyTier || '',
      daysToShiftStart: agency.daysToShiftStart ?? 100, // default to 100 only if undefined
    });
  }
}, [agency]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isEdit) {
      await updateAgency({ id, ...form });
    } else {
      await createAgency(form);
    }
    alert('Agency saved!');
    navigate('/admin/agencies');
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3, maxWidth: 500 }}>
       <Card className="mb-4 custom-card-bg2">
  <Card.Header className="fw-bold">Agency Information</Card.Header>
  <Card.Body>

      <Typography variant="h5" mb={2}>
        {isEdit ? 'Edit Agency' : 'Create Agency'}
      </Typography>

      <TextField
        label="Name"
        name="agencyName"
        fullWidth
        margin="normal"
        value={form.agencyName}
        onChange={handleChange}
        required
      />
      <TextField
        label="Address"
        name="agencyAddress"
        fullWidth
        margin="normal"
        value={form.agencyAddress}
        onChange={handleChange}
        required
      />
      <TextField
        label="Phone"
        name="agencyPhone"
        fullWidth
        margin="normal"
        value={form.agencyPhone}
        onChange={handleChange}
        required
      />
      <TextField
        label="Email"
        name="agencyEmail"
        type="email"
        fullWidth
        margin="normal"
        value={form.agencyEmail}
        onChange={handleChange}
        required
      />

      

      <TextField
        label="Tier"
        name="agencyTier"
        select
        fullWidth
        margin="normal"
        value={form.agencyTier}
        onChange={handleChange}
        required
      >
        {tiers.map((tier) => (
          <MenuItem key={tier} value={tier}>
            {tier}
          </MenuItem>
        ))}
      </TextField>

    <TextField
  label="Visible to agency in x number of days to start of shift"
  name="daysToShiftStart"
  type="number"
  fullWidth
  margin="normal"
  value={form.daysToShiftStart}
  onChange={(e) => handleChange({ target: { name: e.target.name, value: Number(e.target.value) } })}
  required
  inputProps={{ min: 1, max: 100 }}
/>

       

      <Button type="submit" variant="contained" sx={{ mt: 2 }}>
        {isEdit ? 'Update' : 'Create'}
      </Button>

        </Card.Body>
      </Card>

    </Box>
  );
};

export default AgencyFormScreen;
